import type { AdInfoSlotPayload } from "common-types";
import { getAllConfiguredSlotSizes } from "./getSlotSizes";
import type { AdNode } from "../../../core/AdNode";

export function buildSlotInfo(
  slot: googletag.Slot,
  node: AdNode,
  size?: string,
): AdInfoSlotPayload["slotInfo"] {
  const slotResponseInfo = slot.getResponseInformation?.();
  if (!slotResponseInfo) {
    return undefined;
  }

  return {
    advertiserId: slotResponseInfo.advertiserId,
    creativeId: slotResponseInfo.creativeId,
    lineItemId: slotResponseInfo.lineItemId,
    orderId: slotResponseInfo.campaignId,
    selectedSize: size,
    configuredSizes: getAllConfiguredSlotSizes(node),
  };
}
